module.exports = __webpack_public_path__ + "static/media/DC_F_Jacquard_Meda_Ind.Blue_Peri.88330e1e.png";